var map = {
	"./knuter-2019-Bergen.json": [
		648,
		648
	],
	"./knuter-2019-Oslo.json": [
		242,
		242
	],
	"./knuter-2019-Stavanger.json": [
		912,
		912
	],
	"./knuter-2019-Trondheim.json": [
		453,
		453
	],
	"./knuter-2020-Askim.json": [
		557,
		557
	],
	"./knuter-2020-HNH_VGS.json": [
		839,
		839
	],
	"./knuter-2020-Oslo.json": [
		808,
		808
	],
	"./knuter-2020-Trondheim.json": [
		254,
		254
	],
	"./knuter-2021-Oslo.json": [
		96,
		96
	],
	"./knuter-2021-Vestland.json": [
		801,
		801
	],
	"./knuter-2022-Oslo.json": [
		586,
		586
	],
	"./knuter-2022-Trondheim.json": [
		692,
		692
	],
	"./knuter-2022-Vestland.json": [
		337,
		337
	],
	"./knuter-2022-Viken.json": [
		490,
		490
	],
	"./knuter-2023-Bodø.json": [
		353,
		353
	],
	"./knuter-2023-Oslo.json": [
		831,
		831
	],
	"./knuter-2023-Vestland.json": [
		251,
		251
	],
	"./knuter-2023-Viken.json": [
		293,
		791
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 199;
module.exports = webpackAsyncContext;